import * as qs from 'qs'
import * as React from 'react'
import { navigate as gatsbyNavigate, default as GatsbyLink } from 'gatsby-link'
import { navigate as routerNavigate } from '@gatsbyjs/reach-router'
import { LOCALES } from '../locales'


let useDefaultNavigate = true

export function setUseDefaultNavigate(newVal) {
    useDefaultNavigate = newVal
}

/**
 * Variation of navigate that sets the locale prefix of the target URL
 */
export function navigate(to: string, locale: string) {
    let parsed = qs.parse(to)

    if (to.charAt(0) !== '/') {
        return gatsbyNavigate(to)
    }

    let parts = to.split('/')

    if (!LOCALES.map(i => i.shortCode).includes(parts[1])) {
        // First part of the path is not a known locale, add it
        parts.splice(1, 0, locale)
    } else {
        // First part of the path is a known locale, but might be different
        // from the requested locale, replace it to be sure
        parts[1] = locale
    }

    let targetPath = parts.join('/')
    return useDefaultNavigate ? gatsbyNavigate(targetPath) : routerNavigate(targetPath)
}

export function Link ({to, children}) {
    if (useDefaultNavigate) {
        return React.createElement(GatsbyLink, {to}, children)
    } else {
        return React.createElement('a', {href: to}, children)
    }
}
